import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import kingdomImg from '../../assets/logo_kingdom_256px.png';

function PaginaPublica({ titulo, imagenes = [] }) {
  const [showModal, setShowModal] = useState(false);
  const [imagenActiva, setImagenActiva] = useState(null);


  const esRevista = titulo === "Revista";
  const sinContenido = imagenes.length === 0;


  return (
    <div className="bg-dark min-vh-100 text-light">
      {/* NAVBAR */}
      {!esRevista && (
  <div className="navbar navbar-dark bg-dark m-0 p-0 py-1 position-relative">
    <div className="container-fluid">

      {/* Logo */}
      <div className="navbar-brand card flex-row bg-dark m-0 p-0">
        <img src={kingdomImg} width="50" />
        <div className="ps-2 my-auto d-none d-sm-inline">
          <div className="cargoHeader lh-sm">
            Chicken's<br />Kingdom
          </div>
        </div>
      </div>

      {/* Título centrado */}
      <div
        className="text-light fw-bold fs-6 text-uppercase position-absolute top-50 start-50 translate-middle text-center"
      >
        {esRevista ? "Revista" : sinContenido ? "En construcción" : titulo}
      </div>

    </div>
  </div>
)}

      {/* CONTENIDO */}
      <div className="container-fluid px-4 text-center">

        {/* BOTONES SOLO PARA REVISTA */}
        {esRevista && (
           <div className="d-flex flex-column gap-4">
          <Bloque
            icono="🎓"
            titulo="Capacitaciones"
            texto="La capacitacion es esencial para mejorar el desempeño
                   laboral, actualizar conocimientos y dotar al personal de nuevas
                   herramientas. Su funcion principal es promover la mejora continua
                   , fortalecer habilidades y asegurar que las tareas se realicen con calidad
                   , eficiencia y en un ambiente positivo."
            ruta="/capacitaciones"
          />
          <Bloque
            icono="🎉"
            titulo="Fexco Inauguracion"
            texto="Este proyecto nos llena de un inmenso orgullo, 
                    pues se convierte en nuestra tercera sucursal 
                    dedicada a despacho, permitiéndonos  abastecer 
                    de manera eficiente y rápida a toda la creciente 
                    Zona Sur de Cochabamba."
            ruta="/fexcoInauguracion"
          />
          <Bloque
            icono="🤝"
            titulo="Posesion Cochabamba"
            texto="Queremos que entiendan que esta 
                    posesión es una manifestación clara de 
                    la confianza total que la organización 
                    deposita en su potencial y liderazgo. 
                    Este gran paso es solo el inicio de una 
                    trayectoria llena de desafíos gratifican
                    tes, nuevos aprendizajes y oportunida
                    des trascendentales dentro de nuestra 
                    organización."
            ruta="/posesionCbba"
          />
          <Bloque
            icono="⭐"
            titulo="Posesion Santa Cruz"
            texto="La ciudad de Santa Cruz, un motor de 
                    crecimiento y dinamismo para Kingdom, 
                    nos ofrece hoy un motivo especial para 
                    celebrar. Con inmensa alegría, dedicamos 
                    este espacio a reconocer y felicitar a nues
                    tro talentoso equipo de Cajeras y Cajeras 
                    Jr. que han logrado un merecido ascenso.
                    Ustedes son la primera y más importante 
                    cara de Chicken's Kingdom. Su rol en la 
                    sucursal es la clave que asegura que la 
                    experiencia de nuestros clientes inicie y 
                    termine con una sonrisa."
            ruta="/posesionSC"
          />
          <Bloque
            icono="🏆"
            titulo="Campeonato Santa Cruz"
            texto="En estas jornadas deportivas notamos 
                  compañerismo en torno a un objetivo 
                  común, mujeres y varones se destacaron 
                  por el juego limpio y respeto con sus 
                  compañeros"
            ruta="/campeonatoSC"
          />
          <Bloque
            icono="🎊"
            titulo="Eventos Santa Cruz"
            texto=""
            ruta="/eventosSC"
          />
          <Bloque
            icono="📅"
            titulo="Eventos Cochabamba"
            texto=""
            ruta="/eventosCbba"
          />
          
          </div>
        )}

        {/* MENSAJE EN CONSTRUCCIÓN */}
        {!esRevista && sinContenido && (
          <h3 className="text-muted mt-5">🚧 En construcción 🚧</h3>
        )}

        {/* IMÁGENES */}
        {!sinContenido && (
          <div className="row">
            {imagenes.map((img, index) => (
              <div key={index} className="col-md-4 mb-4">
                <img
                  src={img}
                  alt={`${titulo}-${index}`}
                  className="img-fluid rounded shadow"
                  style={{
                    width: '100%',
                    height: '450px',
                    objectFit: 'cover',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setImagenActiva(img);
                    setShowModal(true);
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content bg-dark">
                <div className="modal-header border-0">
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                  />
                </div>
                <div className="modal-body text-center">
                  <img
                    src={imagenActiva}
                    className="img-fluid"
                    style={{ maxHeight: '90vh' }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
}

function Bloque({ icono, titulo, texto, ruta }) {
  return (
    <div className="card bg-secondary bg-opacity-10 border border-warning text-light p-4 bloque-empresa">
      <div className="row align-items-center">

        <div className="col-md-2 text-center fs-1">
          {icono}
        </div>

        <div className="col-md-8">
          <h4 className="fw-bold mb-1">{titulo}</h4>
          <p className="text-secondary text-white mb-0">{texto}</p>
        </div>

        <div className="col-md-2 text-center mt-3 mt-md-0">
          <Link to={ruta} className="btn btn-warning fw-bold px-4">
            Ver fotos
          </Link>
        </div>

      </div>
    </div>
  );
}

export default PaginaPublica;
